module.exports = __webpack_public_path__ + "static/media/default-community-category-5.9b08069c.jpg";